import { Easy69_v1 } from "./frfr-easy69-utils";
// import { js_utils } from "./frfr-js-utils";
// import { json_utils } from "./frfr-json-utils";




// const frfr_lib_changes_id = '/FRFR/frfr-routing-utils.js/changes_id2026-02-09r1/';



// FRFR UNDER CONSTRUCTION FRFR TODO
/* 
FrFr FRIENDLY FRAMEWORK
frfr-routing-utils.js
Version ID: 1a 2026-02-09r1
by 
// Please describe here if you customized this file
*/


//

////

/*
method
.execute_routing_and_return_val



special_instance_obj = {
  returned_value // defualt undefined


  originalUrl

  TODO popisati sve metode i propertije od req obj


};
*/


//
const SLASH = '/';
const WILDCARD = '*'; // matches zero or more characters
// const QUESTIONMARK = '?'; // matches single character
const COLON = ':';

//
const viarouter69_engine = {};





//
const _is_pattern_wildcard_segment = (s) => {
  if (s === '*') {
    return true;
  } else {
    return false;
  }
};
//
const _is_pattern_param_segment = (s) => {
  // if (typeof s === 'string' && s !== '' && s.startsWith(':')) {
  if (Easy69_v1.str_starts_with(s, ':')) {
    return true;
  } else {
    return false;
  }
};


/*
// IRDO - intermediate (semi-finished) routing data object
const irdo_create = (url_path) => {
  // IRDO - intermediate routing data object - semi-finished
  let irdo = {
    readme: 'this is IRDO - intermediate (semi-finished) routing data object',
    original_url_path: url_path,
    url_path: url_path,
    path_params: {}, // url query params
    getmethod_params: {}, // url query params
    //
    is_match: false,
    is_match_full: false,
    is_match_prefix: false,
    path_original: null, // TODO
    path_prefix: null, //
    path_sufix: null, // path sufix for subrouter
    params: {}, // path params
    query: {}, // url query params
  };
  return irdo;
};
*/


//
export const routing_utils_match_and_extract_params_v3 = (path, pattern) => {
  const params = {};
  let _is_fail = false; //
  let _is_match_perfect = false; //
  let _is_match_prefix = false; //
  let _is_wildcard_on_end = false;
  let path_prefix = null;
  let path_sufix = null;

  let pathSegments = [];
  let patternSegments = [];
  if (typeof path === 'string') {
    pathSegments = path.split('/').filter(Boolean);
  }
  if (typeof pattern === 'string') {
    patternSegments = pattern.split('/').filter(Boolean);
  }
  // const path_original_prepared = '/' + pathSegments.join('/');
  const path_original_prepared = Easy69_v1.arr_join(pathSegments, '/');

  const pathSegments_length = pathSegments.length;
  const patternSegments_length = patternSegments.length;

  /*
  pathIdx advances EVERY TIME we consume a path segment:
  - Literal match → pathIdx++
  - Named param → pathIdx++  
  - Non-trailing * → pathIdx++
  
  i advances ONLY when we move to next pattern segment
  
  pathIdx catches up and overtakes i as we consume path segments!
  */

  // let pathIdx = 0; // pathIdx - how many path segments consumed so far
  let lastConsumedPathSegmentIndex = -1;
  let wildcardIndex = 0;
  for (let i = 0; i < patternSegments_length; i++) { // iterate over pattern segments
    // i - current pattern segment index being processed
    const patternSeg = patternSegments[i];
    // console.log('i', i, 'patternSeg', patternSeg);
    let _is_match_in_iteration = false;
    //
    if (i < pathSegments_length) { // CASE enough path segments

      // STEP Named parameter like :id
      if (_is_pattern_param_segment(patternSeg)) { // CASE Named parameter like :id
        // Normal named param
        // const paramName = patternSeg.slice(1); // STRING SLICE
        const paramName = Easy69_v1.str_slice(patternSeg, 1); // STRING SLICE
        params[paramName] = pathSegments[i];
        _is_match_in_iteration = true;
      }

      // STEP Wildcard *
      if (_is_match_in_iteration === false && _is_pattern_wildcard_segment(patternSeg)) { // CASE wildcard *
        if (i === patternSegments_length - 1) { // CASE wildcard on end of pattern
          // single /* for greedy multi-segment capture!
          // Trailing * captures everything remaining
          _is_wildcard_on_end = true;
          // params[wildcardIndex] = pathSegments.slice(i).join('/'); // No ++ need
          const wildcard_path_segments = Easy69_v1.arr_slice(pathSegments, i);
          // params[wildcardIndex] = wildcard_path_segments.join('/');
          params[wildcardIndex] = Easy69_v1.arr_join(wildcard_path_segments, '/');
          wildcardIndex++; // you DON'T need wildcardIdx++ for the trailing wildcard case!
          _is_match_in_iteration = true;
          // EXIT
          break; // Explicitly exit for loop since we consumed everything
        } else {
          params[wildcardIndex] = pathSegments[i];
          wildcardIndex++;
          _is_match_in_iteration = true;
        }
      }

      // STEP Literal segment
      if (_is_match_in_iteration === false) { // CASE Literal segment
        if (pathSegments[i] === patternSeg) {
          _is_match_in_iteration = true;
        } else { // FAIL mismatch in literal segment
          _is_fail = true;
          break; // Explicitly exit for loop since FAIL mismatch in literal segment
        }
      }

    } else { // FAIL Not enough path segments // CASE path is shorter than pattern
      _is_fail = true;
      break; // Explicitly exit for loop since FAIL Not enough path segments
    }

    //
    if (_is_match_in_iteration === true) { // succesfully consumed regular (not wildcard on end) path segment
      // pathIdx++; // **pathIdx increments AFTER successful match!**
      lastConsumedPathSegmentIndex = i;
    } else {
      // _is_match_final = false;
      _is_fail = true;
      break; // Explicitly exit for loop since FAIL
    }
    // console.log('* lastConsumedPathSegmentIndex', lastConsumedPathSegmentIndex);
  } // end of for

  // ----- after all pattern segments iterations
  if (_is_fail === true) { // CASE fail in pattern segments matching
    _is_match_perfect = false;
    _is_match_prefix = false;
  } else {
    if (_is_wildcard_on_end === true) { // ok
      // do nothing
      _is_match_perfect = true;
      // prefix match
      _is_match_prefix = true;
      path_sufix = '/';
      // const prefix_path_segments = pathSegments.slice(0, lastConsumedPathSegmentIndex + 1);
      const prefix_path_segments = Easy69_v1.arr_slice(pathSegments, 0, lastConsumedPathSegmentIndex + 1);
      // path_prefix = '/' + prefix_path_segments.join('/');
      path_prefix = Easy69_v1.arr_join(prefix_path_segments, '/');
    } else { // potential rest of the path
      // console.log('potential rest of the path');
      if (lastConsumedPathSegmentIndex > -1) { // CASE pattern and path are longer than zero segments
        if (lastConsumedPathSegmentIndex === (pathSegments_length - 1)) { // CASE pattern and path are same count of segments
          _is_match_perfect = true;
          // prefix match
          _is_match_prefix = true;
          path_sufix = '/';
          // const prefix_path_segments = pathSegments.slice(0, lastConsumedPathSegmentIndex + 1);
          const prefix_path_segments = Easy69_v1.arr_slice(pathSegments, 0, lastConsumedPathSegmentIndex + 1);
          // path_prefix = '/' + prefix_path_segments.join('/');
          path_prefix = Easy69_v1.arr_join(prefix_path_segments, '/');
        } else { // CASE path is longer than pattern
          _is_match_perfect = false;
          // prefix match
          _is_match_prefix = true;
          // const sufix_path_segments = pathSegments.slice(lastConsumedPathSegmentIndex + 1);
          const sufix_path_segments = Easy69_v1.arr_slice(pathSegments, lastConsumedPathSegmentIndex + 1);
          // path_sufix = '/' + sufix_path_segments.join('/');
          path_sufix = Easy69_v1.arr_join(sufix_path_segments, '/');
          // const prefix_path_segments = pathSegments.slice(0, lastConsumedPathSegmentIndex + 1);
          const prefix_path_segments = Easy69_v1.arr_slice(pathSegments, 0, lastConsumedPathSegmentIndex + 1);
          // path_prefix = '/' + prefix_path_segments.join('/');
          path_prefix = Easy69_v1.arr_join(prefix_path_segments, '/');
        }
      } else { // CASE pattern has zero segments
        if (pathSegments_length === 0) { // CASE path and pattern are zero segments
          _is_match_perfect = true;
          // prefix match
          _is_match_prefix = true;
          path_prefix = '/';
          path_sufix = '/';
        } else { // CASE path is longer than pattern
          _is_match_perfect = false;
          // prefix match
          _is_match_prefix = true;
          path_sufix = path_original_prepared;
          path_prefix = '/';
        }
      }
    }
  }

  // finished
  const matching_pack = {
    is_match: _is_match_perfect,
    is_match_full: _is_match_perfect,
    is_match_prefix: _is_match_prefix,
    params, // path params
    path_original: path,
    path_original_prepared, // TODO
    path_prefix, //
    path_sufix, // path sufix for subrouter
    // path_sufix_for_subrouter: '/subpath/subpath...', // TODO
    debug: {
      lastConsumedPathSegmentIndex,
      pathSegments_length: pathSegments_length,
      pattern: pattern,
      patternSegments_length: patternSegments_length,
    },
  };
  return matching_pack;
};

